import React, { HTMLAttributes, DetailedHTMLProps, HtmlHTMLAttributes } from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'dw-unifiedheader': DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>;
      'personal-profile': DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>;
      'my-account-docuware-id': DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>;
      'dw-footer': DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>;
      'company-relations': DetailedHTMLProps<HtmlHTMLAttributes<HTMLElement>, HTMLElement>;
      'people-tile': DetailedHTMLProps<HtmlHTMLAttributes<HTMLElement>, HTMLElement>;
      'company-master-data': DetailedHTMLProps<HtmlHTMLAttributes<HTMLElement>, HTMLElement>;
      'payment-methods': DetailedHTMLProps<HtmlHTMLAttributes<HTMLElement>, HTMLElement>;
      'company-master-data-logo-upload': DetailedHTMLProps<HtmlHTMLAttributes<HTMLElement>, HTMLElement>;
    }
  }
}